import React from 'react';
import I18n from '@/modules/i18n';
import Icon from '@/components/ui/Icon';
import showToast from '@/components/common/Toast';
import { Button } from '@/components/ui/Buttons';
import useUpdateSlideMascot from '@/hooks/api/useUpdateSlideMascot';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import { ISlide } from '@/components/admin/SlideShow/stores/useSlideShowStore';

interface ScoutButtonProps {
  slide: ISlide;
}

const ScoutButton = ({ slide }: ScoutButtonProps) => {
  const updateSlide = useSlideShowContext(state => state.updateSlide);
  const { mutate } = useUpdateSlideMascot(slide.id);

  const isEnabled = !!slide.mascotEnabled;
  const isDisabled = !slide.slideFrameId;

  const toggleScout = () => {
    const nextEnabled = !isEnabled;

    mutate(nextEnabled, {
      onError: () => showToast(I18n.t('unable_to_update_scout'), { msgType: 'error', position: 'bottom-right' }),
      onSuccess: (data) => {
        updateSlide(slide.id, { mascotEnabled: data.mascotEnabled ?? nextEnabled });
      },
    });
  };

  return (
    <Button
      outlineStyle
      small
      className="tw-mt-3"
      color={isEnabled ? 'red' : 'purple'}
      disabled={isDisabled}
      onClick={toggleScout}
    >
      <span className="tw-flex tw-items-center">
        <Icon className="tw-mr-2" icon={isEnabled ? 'Close' : 'Add'} size={12} />
        {I18n.t(isEnabled ? 'remove_scout' : 'add_scout')}
      </span>
    </Button>
  );
};

export default ScoutButton;
